<template>
	<div
		v-if="hasLinkToEdit"
		class="link-details"
	>
		<LinkDetails
			:link="linkToEdit"
		/>
	</div>
</template>

<script>
import LinkDetails from '@/components/LinkDetails.vue';
import { mapGetters } from 'vuex';

export default {
	name: 'WidgetLinkDetails',

	components: {
		LinkDetails,
	},

	data() {
		return {
			link: {},
		};
	},

	computed: {
		...mapGetters([
			'linkToEdit',
		]),
		hasLinkToEdit() {
			return !!this.linkToEdit;
		},
	},
};
</script>

<style>

</style>
